import { useKeycloak } from "@react-keycloak/web";

import React from "react";
import { Route } from "react-router-dom";
import ProtectedRoutes from "./protectedRoutes";

const Routes = (props) => {
  const { keycloak } = useKeycloak();

  return <>{!!keycloak.authenticated && <Route path="/*" render={() => <ProtectedRoutes {...props} />} />}</>;
};

export default Routes;
